"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseCopy = void 0;
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var utils_1 = require("../utils");
var create_translate_1 = require("./create-translate");
var generate_keys_1 = require("./generate-keys");
function createUseCopy(initialComponents) {
    return function useCopy(_a) {
        var defaultTranslations = _a.defaultTranslations, _b = _a.components, components = _b === void 0 ? {} : _b, _c = _a.keys, keys = _c === void 0 ? {} : _c;
        var _d = (0, react_i18next_1.useTranslation)(), i18n = _d.i18n, t = _d.t;
        var Translate = (0, create_translate_1.createTranslate)(initialComponents);
        loadDefaultTranslations(i18n, defaultTranslations);
        var lookup = (0, react_1.useMemo)(function () {
            // this un-nests the first actual translations out from underneath the locale:
            // { en: {x: y}, fr: {x: z}} -> {x: y}
            // Ideally this should be the most complete translation (probably 'en')
            // TODO: once we get round to lazy-load translations, we need a more reliable
            // way of extracting this
            var translations = Object.values(defaultTranslations)[0] || {};
            var pathLookup = (0, generate_keys_1.generateKeys)(translations);
            return __assign(__assign({}, pathLookup), keys);
        }, [defaultTranslations, keys]);
        return {
            copy: function (key, options) { return t(lookup[key], options); },
            Copy: function (_a) {
                var copyKey = _a.copyKey, _b = _a.values, values = _b === void 0 ? {} : _b, _c = _a.props, props = _c === void 0 ? {} : _c;
                return (react_1.default.createElement(Translate, { i18nKey: lookup[copyKey], components: components, props: props, values: values }));
            },
        };
    };
}
exports.createUseCopy = createUseCopy;
function loadDefaultTranslations(i18n, defaultTranslations) {
    if (!i18n.isInitialized) {
        return;
    }
    Object.entries(defaultTranslations).forEach(function (_a) {
        var lng = _a[0], translations = _a[1];
        if (!i18n.languages.includes(lng)) {
            return;
        }
        var resourceBundle = i18n.getResourceBundle(lng, 'cp-ui-tools') || {};
        if (!areTranslationsLoaded(resourceBundle, translations)) {
            i18n.addResourceBundle(lng, 'cp-ui-tools', translations, true);
        }
    });
}
function areTranslationsLoaded(resourceBundle, translations) {
    return (0, utils_1.existsWithin)(translations, resourceBundle);
}
